import { NgModule } from '@angular/core';
import { CronJobComponent } from './cron-job.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	imports: [
		CommonModule,
		FontAwesomeModule,
		MatInputModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatFormFieldModule,
		DisableAutocompleteDirectiveModule,
		MatTooltipModule,
	],
  declarations: [CronJobComponent],
  exports: [
    CronJobComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class CronJobModule {}
